import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=d5441526&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"
import style0 from "./EventView.vue?vue&type=style&index=0&id=d5441526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5441526",
  null
  
)

export default component.exports